// extracted by mini-css-extract-plugin
var _1 = "RequestCriticalReasonTag-moduleRequestCriticalReasonTag__z4U1n";
export { _1 as "RequestCriticalReasonTag" }
